import { render, staticRenderFns } from "./AccountsForm.vue?vue&type=template&id=96077840&"
import script from "./AccountsForm.vue?vue&type=script&lang=js&"
export * from "./AccountsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports